import { useState, useEffect, useRef } from "react";
import { Badge } from "@/components/ui/badge";
import { Card } from "@/components/ui/card";
const advantages = [{
  id: 1,
  title: "Removibles",
  description: "es y también para comer lo que quiera.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685383/img/63-rio.jpg",
  alt: "Removibles",
  number: "01"
}, {
  id: 2,
  title: "Higiénicos",
  description: "La única alternativa ortodóntica que permite sacarla de la boca para comer, cepillarse los dientes y lavarla fácilmente.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685383/img/64-rio.jpg",
  alt: "Higiénicos",
  number: "02"
}, {
  id: 3,
  title: "Sin Dolor",
  description: "Los alineadores al no lacerar las mejillas, lógicamente no duelen como sí lo hacen los brackets tradicionales.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685383/img/66-rio.jpg",
  alt: "Sin Dolor",
  number: "03"
}, {
  id: 4,
  title: "Dental Monitoring",
  description: "El Ortodoncista podrá usar está Plataforma de Monitoreo para controlar remotamente el estado y adaptación de los alineadores, IDEAL PARA PACIENTES QUE NO VIVEN EN SU MISMA CIUDAD.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685383/img/67-rio.jpg",
  alt: "Dental Monitoring",
  number: "04"
}];
export default function Ventajas() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setVisible(true);
    }, {
      threshold: 0.15
    });
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);
  const active = advantages[activeIndex];
  return <section ref={sectionRef} className="dark bg-background text-foreground min-h-screen relative overflow-hidden">
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,700;0,900;1,700&family=DM+Sans:wght@300;400;500&display=swap');`}</style>

      <div className="absolute inset-0 opacity-5 pointer-events-none" style={{
      backgroundImage: "repeating-linear-gradient(0deg, transparent, transparent 79px, rgba(255,255,255,0.4) 80px), repeating-linear-gradient(90deg, transparent, transparent 79px, rgba(255,255,255,0.4) 80px)"
    }} />

      <div className={`relative z-10 max-w-7xl mx-auto px-6 lg:px-12 py-20 lg:py-28 transition-opacity duration-700 ${visible ? "opacity-100" : "opacity-0"}`}>
        <div className="flex flex-col lg:flex-row gap-16 lg:gap-24">

          <div className="lg:w-5/12 flex flex-col justify-between">
            <div>
              <div className="flex items-center gap-3 mb-6 !text-[rgba(8,215,247,1)]">
                <div className="h-px w-10 bg-primary" />
                <Badge variant="outline" className="inline-flex items-center justify-center rounded-md border px-2 py-0.5 w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&]:hover:bg-accent [a&]:hover:text-accent-foreground border-primary uppercase tracking-[0.2em] text-xs font-medium !text-[rgba(8,215,247,1)] dark:aria-invalid:ring-destructive/40" style={{
                fontFamily: "'DM Sans', sans-serif"
              }}>
                  Sistema Rio3D
                </Badge>
              </div>

              <h2 className="text-6xl lg:text-8xl font-black leading-none tracking-tight text-foreground mb-8" style={{
              fontFamily: "'Playfair Display', serif"
            }}>
                Ven<span className="italic !text-[rgba(8,215,247,1)]">ta</span>jas
              </h2>

              <p className="text-muted-foreground text-base lg:text-lg leading-relaxed max-w-md" style={{
              fontFamily: "'DM Sans', sans-serif",
              fontWeight: 300
            }}>
                Son innumerables las ventajas del sistema Rio3D, de las cuales se destacan su insuperable comodidad de uso, verdaderamente higiénicos y fácilmente Monitoreados desde cualquier lugar donde se encuentre el paciente a través de su smartphone.
              </p>
            </div>

            <nav className="mt-12 lg:mt-0 flex flex-col gap-1">
              {advantages.map((item, idx) => <button key={item.id} onClick={() => setActiveIndex(idx)} className={`group flex items-center gap-5 py-4 px-5 rounded-lg text-left transition-all duration-300 border ${activeIndex === idx ? "bg-primary/10 border-primary/40" : "border-transparent hover:bg-muted/50 hover:border-border"}`}>
                  <span className={`text-xs font-mono transition-colors duration-300 ${activeIndex === idx ? "text-primary" : "text-muted-foreground"}`} style={{
                fontFamily: "'DM Sans', sans-serif"
              }}>
                    {item.number}
                  </span>
                  <span className={`text-lg font-bold transition-colors duration-300 ${activeIndex === idx ? "text-foreground" : "text-muted-foreground group-hover:text-foreground"}`} style={{
                fontFamily: "'Playfair Display', serif"
              }}>
                    {item.title}
                  </span>
                  {activeIndex === idx && <span className="ml-auto text-primary text-sm font-mono">&rsaquo;&rsaquo;</span>}
                </button>)}
            </nav>
          </div>

          <div className="lg:w-7/12 flex flex-col gap-6">
            <Card className="relative overflow-hidden border-0 bg-card rounded-2xl group">
              <div className="relative aspect-[4/3] overflow-hidden">
                {advantages.map((item, idx) => <img key={item.id} src={item.image} alt={item.alt} className={`w-full h-auto absolute inset-0 object-cover transition-all duration-700 ease-in-out ${activeIndex === idx ? "opacity-100 scale-100" : "opacity-0 scale-105"}`} style={{
                width: "100%",
                height: "100%",
                objectFit: "cover"
              }} />)}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-8">
                  <p className="text-4xl lg:text-5xl font-black text-white leading-tight mb-2" style={{
                  fontFamily: "'Playfair Display', serif"
                }}>
                    {active.title}
                  </p>
                  <div className="h-0.5 w-12 bg-primary mt-3" />
                </div>
                <div className="absolute top-6 right-6">
                  <span className="text-white/20 text-7xl font-black leading-none" style={{
                  fontFamily: "'Playfair Display', serif"
                }}>
                    {active.number}
                  </span>
                </div>
              </div>
            </Card>

            <Card className="bg-card border border-border rounded-2xl p-8">
              <p className="text-foreground text-base lg:text-lg leading-relaxed" style={{
              fontFamily: "'DM Sans', sans-serif",
              fontWeight: 300
            }}>
                {active.description}
              </p>
            </Card>

            <div className="flex gap-3">
              {advantages.map((item, idx) => <button key={item.id} onClick={() => setActiveIndex(idx)} className="flex-1 h-1.5 rounded-full transition-all duration-400 !bg-[rgba(8,215,247,1)]" />)}
            </div>

            <div className="grid grid-cols-4 gap-3">
              {advantages.map((item, idx) => <button key={item.id} onClick={() => setActiveIndex(idx)} className={`relative overflow-hidden rounded-xl aspect-square transition-all duration-300 ${activeIndex === idx ? "ring-2 ring-primary ring-offset-2 ring-offset-background scale-105" : "opacity-50 hover:opacity-80 hover:scale-102"}`}>
                  <img src={item.image} alt={item.alt} className="w-full h-auto object-cover" style={{
                width: "100%",
                height: "100%",
                objectFit: "cover"
              }} />
                  <div className={`absolute inset-0 bg-background/40 transition-opacity duration-300 ${activeIndex === idx ? "opacity-0" : "opacity-60"}`} />
                </button>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}